export default {
    TYPE_PERCENT: 'percent',
    TYPE_AMOUNT: 'amount',
  };